import React, { useEffect, useState, useRef } from 'react'
import HtmlParser from 'react-html-parser';
import { Modal } from 'react-bootstrap'
import {
    getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, settings, settingsPassword, getLanguageObj, getResponse, axiosV2
} from '../../helpers/UtilsHelper'
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';

const { app, icons, images, labels, messages } = settings;
const { urls, methods } = app?.backend;

const currentMethod = 'AccountDelete - function';

export default function AccountDelete({
    processValues = {},
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const {
        auth = AuthContextType,
        account = {
            email: '',
            password: ''
        },
        setAccount = () => { },
        showModal = false,
        setShowModal = () => { },

    } = processValues;
    const isMount = useRef(true);
    const [errorPassword, setErrorPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false
    });
    //#endregion variables

    //#region methods
    const deleteAccount = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'deleteAccount';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();
            setShowPassword(false);
            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            //#region Form data validate
            response = deleteFormDataAccountValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion Form data validate

            //#region delete data (account)
            const headers = {
                authorization: `bearer ${auth?.account?.tokenVzLaML?.token}`,
            };
            const data = {
                conditionals: [],
                ordersBy: [],
                method: methods?.accounts?.delete,
                email: account?.email,
                password: account?.password,
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.accounts}/`,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion delete data (account)

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const deleteFormDataAccountValidate = ({
        subMethod = ''
    }) => {
        const currentMethod = 'deleteFormDataAccountValidate';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmpNew({ data: account?.password, subMethod: currentMethod, })?.result) {
                setErrorPassword(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (account?.password?.length < settingsPassword?.maxLength) {
                setErrorPassword(messages?.youMustEnterValidPassword?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => { isMount.current = false; };
    }, []);
    //#endregion methods

    return (
        <Modal backdrop='static'
            onHide={() => setShowModal(false)}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>
            {/* <LoadingSection alt='loadingSection'
                className='overlay dark text-white'
                height={20}
                hidden={!process?.showLoading}
                width={20}
                languageId={languageObj?.id}
                subMethod={currentMethod} /> */}
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='UsersLogo' src={images?.icons?.info} style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.reAuthentication?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className='badge badge-pill py-1 px-2 text-uppercase badge-danger'
                            style={settings?.html?.badges?.micro}>
                            {labels?.delete?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => deleteAccount({ e: e, subMethod: 'onSubmit - form', })}>
                <Modal.Body className='px-4 pt-2'>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.password?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <span className='position-absolute input-icon-left'
                                style={{ cursor: 'pointer', zIndex: 10 }}
                                onClick={() => setShowPassword(!showPassword)}>
                                <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash}></i>
                            </span>
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.password?.[languageObj?.id]}
                                type={showPassword ? 'text' : 'password'}
                                value={account?.password || ''}
                                disabled={process?.showLoading}
                                onChange={(e) => setAccount({ ...account, password: e?.target?.value })}
                                onFocus={() => setErrorPassword('')}
                                placeholder={labels?.password?.[languageObj?.id]} />
                        </div>
                        {errorPassword && <div className='form-text mt-1 form-error-text'>{HtmlParser(errorPassword)}</div>}
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-secondary'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}